import { ListSubheader, Box, List, styled } from "@mui/material";
import { useLocation, matchPath } from "react-router-dom";
import SidebarMenuItem from "./item";
import menuItems from "./items";

// height: 100%;
// position: absolute;
// left: 0px;
// width: 30%;
// top: 0;

const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {
        height: 100%;
        z-index: 3;
       
        
        .MuiBox-root{
           height: 100%;
            left: 0px;
            top: 0; 
          }

      .MuiListItem-root {
        margin-bottom: 5px;
        padding: 2px 0;
        padding-left: ${theme.spacing(0)};
        
        .MuiCollapse-root{ 
        
            .MuiListItem-root{
                width: 98%;
                
               .MuiButton-root {
                   &:hover{
                        background-color: #4C4C4C;
                        color: white;
        }
        }
        }
        
        }

        .MuiBadge-root {
          position: absolute;
          right: ${theme.spacing(3.5)};

          .MuiBadge-standard {
            background: blue;
            font-size: ${theme.typography.pxToRem(10)};
            font-weight: bold;
            color: ${theme.palette.primary.contrastText};
          }
        }
    
        .MuiButton-root {
          margin: auto
          position: relative;
          margin: 0;
          font-size: 16px;
          display: flex;
          text-transform: none;
          color: #A5A7AF;
          width: 90%;          
          background-color: transparent;
          justify-content: flex-start;
          padding: ${theme.spacing(2, 3, 2, 4)};
          border-bottom-left-radius: 10px;
          border-top-left-radius: 10px;
          border-bottom-right-radius: 10px;
          border-top-right-radius: 10px;
          font-family: 'Poppins', sans-serif;
    
          .MuiButton-startIcon,
          .MuiButton-endIcon {
            transition: ${theme.transitions.create(["color"])};

            .MuiSvgIcon-root {
              font-size: inherit;
              transition: none;
            }
          }

          .MuiButton-startIcon {
            font-size: ${theme.typography.pxToRem(20)};
            margin-right: ${theme.spacing(1)};
            color: #84A8C1;
          }
          
          .MuiButton-endIcon {
            margin-left: auto;
            opacity: .8;
            font-size: ${theme.typography.pxToRem(20)};
          }
          
          &.MuiButtonBase-root{
          margin: auto
          }
          
          &.Mui-active{
          border-radius: 30px;
          padding-top:10px;
          padding-bottom:10px;
          color: #84A8C1;
          }
          
            border: 1px solid transparent;
          

          &.active,
          &:hover {
            background-color: rgba(0, 117, 201, 0.20);
            border: 1px solid rgba(0, 117, 201, 0.90);
            color: rgba(14, 67, 105, 0.90);
            font-weight: bold;

            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: #1D5576;
            }
          }
        }
        &.active{
        .MuiButton-startIcon,
            .MuiButton-endIcon {
                color: #0075C9;
            }
        }

        &.Mui-children {
          flex-direction: column;
          left: -18px;

          .MuiBadge-root {
            position: absolute;
            right: ${theme.spacing(7.5)};
          }
        }

        .MuiCollapse-root {
          width: 103%;

          .MuiList-root {
            padding: ${theme.spacing(1.5, 0, 0, 0)};
            margin: 0
            
          }

          .MuiListItem-root {
            padding: 0;
            padding-left: ${theme.spacing(1.2)};
            right: -20px;

            .MuiListItem-root {
              padding: 0;
            }

            .MuiButton-root {
              .MuiBadge-root {
                right: ${theme.spacing(3.5)};
              }
            }

            .MuiButton-root {
              padding: ${theme.spacing(0.7, 3, 0.7, 5.5)};
              background-color: transparent;
                        color: white;
              &.active,        
              &:hover {
                background-color: #4C4C4C;
                        color: white;
              }
            }
          }
        }
      }
    }
`
);

const MenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {
      margin-bottom: ${theme.spacing(1.5)};
      padding: 0;

      & > .MuiList-root {
        padding: 0 ${theme.spacing(0)} ${theme.spacing(1)};
      }
    }

    .MuiListSubheader-root {
      font-weight: bold;
      font-size: ${theme.typography.pxToRem(12)};
      color: lightblue;
      padding: ${theme.spacing(1, 3.5)};
      line-height: 1.4;
    }
`
);

const renderSidebarMenuItems = ({ items, path }) => (
  <div>
    <SubMenuWrapper>
      <List component="div" sx={{ height: "auto!important" }}>
        {items.reduce((ev, item) => reduceChildRoutes({ ev, item, path }), [])}
      </List>
    </SubMenuWrapper>
  </div>
);

const reduceChildRoutes = ({ ev, path, item }) => {
  const key = item.name;

  const exactMatch = item.link
    ? !!matchPath(
        {
          path: item.link,
          end: true,
        },
        path
      )
    : false;

  if (item.items) {
    const partialMatch = item.link
      ? !!matchPath(
          {
            path: item.link,
            end: false,
          },
          path
        )
      : false;

    ev.push(
      <SidebarMenuItem
        key={key}
        active={partialMatch}
        open={partialMatch}
        name={item.name}
        icon={item.icon}
        link={item.link}
        badge={item.badge}
        badgeTooltip={item.badgeTooltip}
      >
        {renderSidebarMenuItems({
          path,
          items: item.items,
        })}
      </SidebarMenuItem>
    );
  } else {
    ev.push(
      <SidebarMenuItem
        key={key}
        active={exactMatch}
        name={item.name}
        link={item.link}
        badge={item.badge}
        badgeTooltip={item.badgeTooltip}
        icon={item.icon}
      />
    );
  }

  return ev;
};

function SidebarMenu() {
  const location = useLocation();

  return (
    <>
      {menuItems.map((section) => (
        <MenuWrapper key={section.heading}>
          <List
            component="li"
            subheader={
              <ListSubheader component="div" disableSticky>
                {section.heading}
              </ListSubheader>
            }
          >
            {renderSidebarMenuItems({
              items: section.items,
              path: location.pathname,
            })}
          </List>
        </MenuWrapper>
      ))}
    </>
  );
}

export default SidebarMenu;
